import { render, staticRenderFns } from "./ReviewVendorDropdownField.vue?vue&type=template&id=455ea663"
import script from "./ReviewVendorDropdownField.vue?vue&type=script&lang=ts"
export * from "./ReviewVendorDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455ea663')) {
      api.createRecord('455ea663', component.options)
    } else {
      api.reload('455ea663', component.options)
    }
    module.hot.accept("./ReviewVendorDropdownField.vue?vue&type=template&id=455ea663", function () {
      api.rerender('455ea663', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/ReviewVendorDropdownField.vue"
export default component.exports